<template>
    <div
        @click.stop.prevent="$emit('click', $event)"
        class="font-weight-bold d-inline-flex align-items-center overflow-hidden border stolen-badge border-width-2 font-size-75 br-50 user-select-none bg-white"
        :style="`--badge-color:${badgeColor};--text-color:${textColor};`"
    >
        <div class="d-flex h-100 align-items-center px-2 stolen-badge-label">
            <slot name="before-label"></slot>{{ label }}
        </div>
        <span class="px-1 stolen-badge-value">{{ value }}<slot name="after-value"></slot></span>
    </div>
</template>

<script>
export default {
    name: 'StolenGitLabBadge',
    props: {
        label: {
            type: String,
            required: true,
        },
        value: {
            type: String | Number,
            required: true,
        },
        badgeColor: {
            type: String,
            default: '#4285F4',
        },
        textColor: {
            type: String,
            default: '#fff',
        },
    },
};
</script>

<style scoped lang="scss">
.border-width-2 {
    border-width: 2px;
}
.stolen-badge {
    border-color: var(--badge-color) !important;
}
.stolen-badge-label {
    color: var(--text-color) !important;
    background: var(--badge-color) !important;
}
.stolen-badge-value {
    // nothing yet :)
}
</style>
